import { Medical } from "@/clients/models/Medical";
import { MedicalService } from "@/clients/services/MedicalService";
import { QueryKeys } from "@/constants/query-keys";
import { guardGetUserFromLocalStorage } from "@/utils/request";
import { useMutation } from "@tanstack/react-query";

export const useUpdateMedical = () => {
  const { mutate, mutateAsync, isPending } = useMutation({
    mutationKey: [QueryKeys.MEDICAL],
    mutationFn: async (medical: Medical) => {
      const user = guardGetUserFromLocalStorage();
      await MedicalService.updateMedicalInfoApiV1MedicalPut(user.id, medical);
    },
  });

  return {
    updateMedical: mutate,
    updateMedicalAsync: mutateAsync,
    isUpdating: isPending,
  };
};
